<template lang="pug">
  div
    .title.mb-3 Список лекций
    div(v-if="islLecture")
      template(v-for="(lecture, idx) in lectures")
        v-card.mb-6.sdo-card(max-width="1000")
          v-card-title.font-weight-bold.text-h4  {{ lecture.name }}
          v-card-text.font-weight-regular.text--primary(v-html="lecture.text")
    div(v-else)
      p Лекции отсутствуют...
</template>

<script>
export default {
  name: 'ContentVideos',
  props: {
    lectures: { type: Array, default: null },
  },
  computed: {
    islLecture() {
      return this.lectures.length;
    },
  },
};
</script>
